<mat-toolbar class="fix-nav" color="primary" >
  <button type="button" mat-icon-button (click)="toggleSidebar()">
    <mat-icon fontIcon="menu"></mat-icon>
  </button>
  
  
  <div class="nav-brand">
    Sri Vigneshwara Jewellery - Pollachi
  </div>
  
  <span class="spacer"></span>
</mat-toolbar>
